/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IMfrmUtagData scriptModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum pageType {
    home = 'home',
    product = 'product',
    category = 'category',
    search = 'search',
    content = 'content',
    shopping_guides = 'shopping_guides',
    brand = 'brand',
    holiday = 'holiday',
    sale = 'sale',
    checkout = 'checkout',
    confirmation = 'confirmation',
    cart = 'cart',
    orderconfirmation = 'orderconfirmation',
    error = 'error'
}

export const enum pageContextType {
    product = 'product',
    search = 'search',
    content = 'content',
    storefront = 'storefront',
    cart = 'cart',
    sale = 'sale',
    checkout = 'checkout',
    orderconfirmation = 'orderconfirmation',
    error = 'error',
    compare = 'compare',
    myaccount = 'myaccount',
    haulaway = 'haulaway',
    orderhistory = 'orderhistory'
}

export interface IMfrmUtagDataConfig {
    pageType?: pageType;
    pageContextType?: pageContextType;
}

export interface IMfrmUtagDataProps<T> extends Msdyn365.IModule<T> {
    config: IMfrmUtagDataConfig;
}
